import { shallowRef } from 'vue';

/** 当前市场详情页 collectionId（供顶栏条幅等壳层读取） */
export const activeMarketDetailCollectionId = shallowRef('');

export function setActiveMarketDetailCollectionId(id) {
  activeMarketDetailCollectionId.value = String(id ?? '').trim();
}

export function clearActiveMarketDetailCollectionId() {
  activeMarketDetailCollectionId.value = '';
}
